module.exports = __webpack_public_path__ + "edf44c7a5dc6846cf4f3718b697769e0.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/DK.svg
// module id = W0CC
// module chunks = 0